import api from "api/api";
import { PipelineEndpoints } from "components/pipeline-components/utils";
import { openModalCSVReader } from "components/mailing-components/csv-reader";
import { openModalOpcoesCorrigirValidacao } from "./modal-opcoes-corrigir-validacao";
import { openModalUploadFile } from "components/modal-upload-file";
import { Toast } from "components/toast";
import { UploadIcon } from "components/vectors/upload-icon";

type OpenModalCorrigirErroValidacaoParams = {
  pipelineId: number;
  mailingId: string;
  errorType: "ENDERECO" | "DADOS_BANCARIOS";
};

async function uploadValidationErrorCSV({
  file,
  mailingId,
  errorType
}: {
  file: File;
  mailingId: string;
  errorType: "ENDERECO" | "DADOS_BANCARIOS";
}) {
  const formData = new FormData();
  formData.append("files", file);

  await api.put(
    `/pipeline/new-pipeline/${mailingId}/digitacao/fix/upload`,
    formData,
    {
      params: { errorType },
      headers: { "Content-Type": "multipart/form-data" }
    }
  );
}

export async function openModalCorrigirErroValidacaoCSV({
  pipelineId,
  mailingId,
  errorType
}: OpenModalCorrigirErroValidacaoParams) {
  if (!pipelineId) {
    Toast({ title: "Pipeline ID inválido", status: "error" });
    return;
  }

  if (!mailingId) {
    Toast({ title: "Mailing ID inválido", status: "error" });
    return;
  }

  const uploadCorrections = async (file: File) => {
    try {
      await uploadValidationErrorCSV({ file, mailingId, errorType });
      Toast({
        title: "CSV corrigido enviado com sucesso",
        status: "success"
      });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      Toast({
        title: "Erro ao enviar CSV corrigido",
        description: errorMessage,
        status: "error"
      });
    }
  };

  const openCSVReaderFlow = async () => {
    try {
      const file = await PipelineEndpoints.downloadValidationErrorCSV(
        pipelineId,
        errorType
      );

      openModalCSVReader({
        file,
        edit: true,
        hiddenColumns: ["ID_ML", "ID_DIG", "ID_MLD"],
        readOnlyColumns: ["CPF"],
        actionButton: {
          children: "Enviar correções",
          leftIcon: <UploadIcon w="18px" h="18px" />
        },
        onConfirmActionButton: async ({ file }) => {
          await uploadCorrections(file);
        }
      });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      Toast({
        title: "Erro ao baixar CSV com erros",
        description: errorMessage,
        status: "error"
      });
    }
  };

  const openBaixarArquivoFlow = async () => {
    try {
      const file = await PipelineEndpoints.downloadValidationErrorCSV(
        pipelineId,
        errorType
      );
      const url = URL.createObjectURL(file);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = file.name;
      anchor.click();
      URL.revokeObjectURL(url);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      Toast({
        title: "Erro ao baixar CSV com erros",
        description: errorMessage,
        status: "error"
      });
    }
  };

  const openUploadArquivoFlow = () => {
    openModalUploadFile({
      title: "Upload do arquivo corrigido",
      message: "Faça o upload do arquivo CSV já corrigido.",
      onConfirm: async (file) => {
        await uploadCorrections(file);
      }
    });
  };

  openModalOpcoesCorrigirValidacao({
    onBaixarArquivo: openBaixarArquivoFlow,
    onUploadArquivo: openUploadArquivoFlow,
    onCorrigirCSV: openCSVReaderFlow
  });
}
